export default {
    COMPONENT: "COMPONENT"
};
